import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { BodyTextLarge, HeadlineTextLarge } from 'Packages/FacetDesign/Components';
import { withValueArray } from 'Helpers/MetaOverride';
import {
  DestinationAccount,
} from 'Views/Page/Content/Templates/CapitalizeRolloverIntroStepTemplate/Content/destinationAccount/destinationAccount';

export const metaOverrideSet = buildFacetDesignOverride()
  .nameOverride('title', {
    _component: () => HeadlineTextLarge,
    _customProps: {
      color: 'textSecondary',
      align: 'center',
    },
  }, overrideReadOnly, { ordinal: 200 })
  .nameOverride('subtitle', {
    _component: () => withValueArray(BodyTextLarge),
    _customProps: {
      align: 'center',
    },
  }, overrideReadOnly)
  .nameOverride(['destinationAccountName', 'secondaryDestinationAccountName'], {
    _component: () => DestinationAccount,
  }, overrideReadOnly);
